export const API_NAME = 'net-report';
export const API_BASE_URL = `${API_NAME}`;

export const DEFAULT_ORDER: 'ASC' | 'DESC' = 'ASC';
export const DEFAULT_ROWS = 10;
